var React = require('react');
var createReactClass = require('create-react-class');
var Link = require('react-router').Link;

var PostListItem = createReactClass({

    handleClick: function(){
        this.props.setPost(this.props.postContainer.fields.category.fields.slug, this.props.postContainer);
    },

	render: function () {

        return (
            <div className="column">
                <div className="list-item">
                    <p className="list-item-title"><Link to={'/blog/' + this.props.postContainer.fields.category.fields.slug + '/' + this.props.postContainer.fields.slug} onClick={this.handleClick}>{this.props.postContainer.fields.title}</Link></p>
                    <p className="list-item-desc">{this.props.postContainer.fields.clientExt_description}</p>
                    <p className="list-item-more"><Link to={'/blog/' + this.props.postContainer.fields.category.fields.slug + '/' + this.props.postContainer.fields.slug} onClick={this.handleClick}>Continue Reading</Link></p>
                </div>
            </div>
        );
    }
});

module.exports = PostListItem;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postListItem.jsx